export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen w-full flex flex-col items-center justify-center overflow-hidden"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            "url('https://static.readdy.ai/image/2500ac09d0252d19a03ba42d5ab6c3f1/ed83c8e88dd488817bf17eeec5d45bcf.jpeg')",
        }}
      />
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-[#475816]/60" />

      {/* Content */}
      <div className="relative z-10 w-full flex flex-col items-center px-4 pt-28 pb-16">

        {/* Box loghi organizzatori */}
        <div className="w-full max-w-2xl flex items-center justify-center px-4">
          <img
            src="https://static.readdy.ai/image/2500ac09d0252d19a03ba42d5ab6c3f1/0e5cf398e3644e115df55955b3fb2737.png"
            alt="Loghi Organizzatori"
            className="w-full h-auto object-contain"
          />
        </div>

        {/* Presentano */}
        <p className="font-['Londrina_Solid'] text-white text-2xl md:text-3xl tracking-[0.25em] uppercase mt-3 mb-3">
          Presentano
        </p>

        {/* Box banner evento - grande */}
        <div className="w-full max-w-5xl flex items-center justify-center px-4 py-2">
          <img
            src="https://static.readdy.ai/image/2500ac09d0252d19a03ba42d5ab6c3f1/79702afde0abefb07c1688fa3edfbe8f.png"
            alt="Festa della Tammorra 2026 - Banner Evento"
            className="w-full h-auto object-contain"
          />
        </div>

        {/* Start ore 20.00 */}
        <div className="mt-5 bg-[#475816] border-2 border-[#c8e04a] rounded-full px-8 py-2">
          <p className="font-['Londrina_Solid'] text-[#c8e04a] text-xl md:text-2xl tracking-[0.2em] uppercase">
            Start ore 20.00
          </p>
        </div>
      </div>
    </section>
  );
}
